/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_Q4Inputs */

const en_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you offer a student discount?`)
};

const de_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gibt es einen Studierendenrabatt?`)
};

const fr_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

const es_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

const it_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

const nl_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

const pl_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

const fi_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

const da_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

const sv_pricing_faq_q4 = /** @type {(inputs: Pricing_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are AI actions?`)
};

/**
* | output |
* | --- |
* | "Do you offer a student discount?" |
*
* @param {Pricing_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_q4 = /** @type {((inputs?: Pricing_Faq_Q4Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_Q4Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_q4(inputs)
	if (locale === "fr") return fr_pricing_faq_q4(inputs)
	if (locale === "es") return es_pricing_faq_q4(inputs)
	if (locale === "it") return it_pricing_faq_q4(inputs)
	if (locale === "nl") return nl_pricing_faq_q4(inputs)
	if (locale === "pl") return pl_pricing_faq_q4(inputs)
	if (locale === "fi") return fi_pricing_faq_q4(inputs)
	if (locale === "da") return da_pricing_faq_q4(inputs)
	if (locale === "sv") return sv_pricing_faq_q4(inputs)
	return en_pricing_faq_q4(inputs)
});